import React from 'react';
import { useParams } from 'react-router-dom';

import { useSystemUserApi } from '../../../api/system-user/useSystemUserApi';

import ResetPassword from '../../../components/screens/auth/reset-password/ResetPassword';

const ResetPasswordContainer = () => {
  const { contactPointExternalReference } = useParams();

  const { resetPassword: resetPasswordRequest } = useSystemUserApi();

  const resetPassword = (password: string, onSuccess: () => void) => {
    resetPasswordRequest({ contactPointExternalReference: contactPointExternalReference!, password }, onSuccess);
  };

  return <ResetPassword resetPassword={resetPassword} />;
};

export default ResetPasswordContainer;
